<template>
  <div class="login">
    <router-view />
  </div>
</template>

